export const MuiTab = {
  MuiTabs: {},
  MuiTab: {
    root: {
      textTransform: "none",
    },
  },
};
